import { httpPostCall } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

export const updateChequeStatusAPI = (requestPayload,state) => {
  debugger
  const url = `${endpoint.cashManagement.chequeDashboard.updateChequeStatus}`;

  return httpPostCall(url, requestPayload, "post", true, { state });
};


export const chequeDateExtensionAPI = (requestPayload,state) => {
  const url = `${endpoint.cashManagement.chequeDashboard.sendForApproval}`;
  return httpPostCall(url, requestPayload, "post", true, { state });
};

export const chequeRevokeAPI = (requestPayload,state) => {
  const url = `${endpoint.cashManagement.chequeDashboard.revokeCheque}`;
  return httpPostCall(url, requestPayload, "post", true, { state });
};
